<template>
	<div>
		<date-picker
			v-model="datePicker"
			lang="en"
			input-class="form-control"
			width="100%"
			:type="dateTimeType"
      :format="format"
      @change="updateDate"
		></date-picker>
		<input type="hidden" :name="hiddenName" v-model="dateObj">
	</div>
</template>
<script>
export default {
	props: ['hiddenName', 'initDate', 'type'],
    data() {
        return {
    		dateObj: this.initDate,
    		datePicker: this.initDate,
        dateTimeType: this.type || 'date',
        format: this.type == 'datetime' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
    	}
   	},

   	methods: {
   		updateDate() {
        console.log(this.datePicker, moment(this.datePicker).format('YYYY-MM-DD HH:mm:ss'));
   			this.dateObj = this.datePicker ? moment(this.datePicker).format('YYYY-MM-DD HH:mm:ss') : null;
   		}
   	}
}
</script>